const accountRootState = {
    parent: 'root',
    url: '/account',
    abstract: true,
    template: '<ui-view></ui-view>'
};

const accountDetailState = {
    url: '/details',
    controllerAs: 'accountDetails',
    template: require('./controllers/details/accountDetails.html'),
    controller: require('./controllers/details/accountDetailsCtrl')
};

const accountChangePasswordState = {
    url: '/changePassword',
    controllerAs: 'changePassword',
    template: require('./controllers/changePassword/changePassword.html'),
    controller: require('./controllers/changePassword/changePasswordCtrl')
};

const accountLogoutState = {
    url: '/logout',
    controllerAs: 'accountLogout',
    controller: require('./controllers/logout/logoutCtrl')
};

export default function (app) {
    app.config($stateProvider => {
        $stateProvider
            .state('account', accountRootState)
            .state('account.details', accountDetailState)
            .state('account.changePassword', accountChangePasswordState)
            .state('account.logout', accountLogoutState);
    });
}



// WEBPACK FOOTER //
// ./Client/app/account/routes.js